module.exports = __webpack_public_path__ + "img/Lanterne_volante.7f7e351.jpg";